import React from "react";

export const SkeletonCards = ({ count = 6 }) => (
  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="skeleton-cards" aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="ab-card overflow-hidden" style={{ animationDelay: `${i * 60}ms` }}>
        <div className="ab-skeleton aspect-video" />
        <div className="p-6 space-y-3">
          <div className="ab-skeleton h-3 w-1/3 rounded-full" />
          <div className="ab-skeleton h-5 w-4/5 rounded-full" />
          <div className="ab-skeleton h-3 w-full rounded-full" />
          <div className="ab-skeleton h-3 w-2/3 rounded-full" />
        </div>
      </div>
    ))}
  </div>
);

export const PageLoader = () => (
  <div className="min-h-[70vh] flex flex-col items-center justify-center gap-8" data-testid="page-loader">
    <span className="font-serif text-2xl md:text-3xl tracking-wide text-ab-ivory/90 animate-pulse">
      ANYANG <span className="text-ab-gold">BETI</span>
    </span>
    <div className="ab-skeleton h-px w-44 rounded-full" />
  </div>
);

export default SkeletonCards;
